module.exports = __webpack_public_path__ + "img/monocycle-crossing.bc3606fe.jpg";